module.exports = __webpack_public_path__ + "static/pixie-cli-6757ce5538f53c6994bc6a2fa27d01de.mp4";